"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateHTML = exports.generateRichtextHTMLStructured = exports.generateRichtextHTML = void 0;

var generateRichtextHTML = function (element, libraryItems) {
  var ckElement = element.querySelector('.ck-editor__editable');

  if (ckElement) {
    var paragraphs = ckElement === null || ckElement === void 0 ? void 0 : ckElement.childNodes;
    paragraphs.forEach(function (paragraph) {
      var div = document.createElement('div');
      div.innerHTML = paragraph.outerHTML;
      var placeholders = div.querySelectorAll('.placeholder.ck-widget');
      placeholders.forEach(function (placeholder) {
        var id = placeholder.id; // @ts-ignore

        var storeItem = window.__LIBRARYITEMSTORE__.get(id);

        placeholder.innerHTML = libraryItems[id] || (storeItem === null || storeItem === void 0 ? void 0 : storeItem.renderedSvg) || (storeItem === null || storeItem === void 0 ? void 0 : storeItem.rendered);
      });
      var autosync = div.querySelector('.content-item-link');

      if (autosync) {
        div.innerHTML = div.innerHTML.replace(autosync.innerHTML, '');
      }

      var tableWidgetSelections = div.querySelectorAll('.ck-widget__selection-handle');

      if (tableWidgetSelections && tableWidgetSelections.length) {
        tableWidgetSelections.forEach(function (tableWidgetSelection) {
          return div.innerHTML = div.innerHTML.replace(tableWidgetSelection.innerHTML, '');
        });
      }

      paragraph.outerHTML = div.outerHTML;
    });
  }

  return (ckElement === null || ckElement === void 0 ? void 0 : ckElement.innerHTML) || '';
};

exports.generateRichtextHTML = generateRichtextHTML;

var generateRichtextHTMLStructured = function (element) {
  var ckElement = element.querySelector('.ck-editor__editable');

  if (ckElement) {
    var paragraphs = ckElement === null || ckElement === void 0 ? void 0 : ckElement.querySelectorAll('.rich-text-editor-paragraph');
    paragraphs.forEach(function (paragraph) {
      var div = document.createElement('div');
      div.innerHTML = paragraph.outerHTML;
      var placeholders = div.querySelectorAll('.placeholder.ck-widget');
      placeholders.forEach(function (placeholder) {
        var id = placeholder.id;
        var table = document.getElementById(id);
        placeholder.innerHTML = table && (table === null || table === void 0 ? void 0 : table.innerHTML) ? table === null || table === void 0 ? void 0 : table.innerHTML : '';
      });
      var autosync = div.querySelector('.content-item-link');

      if (autosync) {
        div.innerHTML = div.innerHTML.replace(autosync.innerHTML, '');
      }

      paragraph.outerHTML = div.outerHTML;
    });
  }

  return (ckElement === null || ckElement === void 0 ? void 0 : ckElement.innerHTML) || '';
};

exports.generateRichtextHTMLStructured = generateRichtextHTMLStructured;

var generateHTML = function (id, libraryItems) {
  return libraryItems[id];
};

exports.generateHTML = generateHTML;